import React, {
  FC,
  ReactNode,
  createContext,
  useContext,
  useLayoutEffect,
  useState
} from 'react';
import { createPortal } from 'react-dom';

import ToggleButtons from './ToggleButtons';

import './SecTreePageHeader.css';

type ToolbarActionsContextValue = {
  target: HTMLDivElement | null;
};

export const SecTreeToolbarActionsContext = createContext<ToolbarActionsContextValue | null>(null);

export const SecTreeToolbarActions: FC<{ children: ReactNode }> = ({ children }) => {
  const context = useContext(SecTreeToolbarActionsContext);
  const [targetReady, setTargetReady] = useState(Boolean(context?.target));

  useLayoutEffect(() => {
    setTargetReady(Boolean(context?.target));
  }, [context?.target]);

  if (!context) {
    return <div className="sec-tree-page-toolbar__actions">{children}</div>;
  }

  if (!context.target || !targetReady) {
    return null;
  }

  return createPortal(children, context.target);
};

const SecTreePageHeader: FC<{ children: ReactNode }> = ({ children }) => {
  const [actionsContainer, setActionsContainer] = useState<HTMLDivElement | null>(null);

  return (
    <SecTreeToolbarActionsContext.Provider value={{ target: actionsContainer }}>
      <div className="sec-tree-page-toolbar">
        <ToggleButtons />
        <div ref={setActionsContainer} className="sec-tree-page-toolbar__actions" />
      </div>
      {children}
    </SecTreeToolbarActionsContext.Provider>
  );
};

export default SecTreePageHeader;
